import type { MenuItem } from '@reader-tracker/shared/components/DropdownMenu'

export const APP_NAME = 'Reader'

export const NAV_ITEMS: MenuItem[] = [
  { label: 'About', href: '/about' },
  { label: 'Library', href: '/library' },
  { label: 'Search', href: '/search' },
]
